import { Switch, Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import React, { useState, useEffect } from 'react'
import {
  ClickceaseDomainMigrationWrapper,
  SwitchWrapper,
  TableText,
} from '../DomainManagmentRow/DomainManagementRow.styled'
import { useGetMigrationMonitorMode } from 'Features/domainsManagement/api/getMigrationMonitorMode'
import { useSetMigrationMonitorMode } from 'Features/domainsManagement/api/setMigrationMonitorMode'

type ClickceaseMigrationProps = {
  domainAddress: string
}

export const ClickceaseMigration = ({ domainAddress }: ClickceaseMigrationProps) => {
  const { t } = useTranslation('domainManagement')
  const { data: migrationDomainsList } = useGetMigrationMonitorMode(true)
  const { mutate } = useSetMigrationMonitorMode()
  const [monitorMode, setMonitorMode] = useState<boolean>(false)

  useEffect(
    () =>
      setMonitorMode(
        !!migrationDomainsList?.find((domain) => domain.address === domainAddress)?.monitorMode
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [migrationDomainsList]
  )

  function handleSetMonitorMode(value: boolean) {
    mutate([domainAddress], { onSuccess: () => setMonitorMode(value) })
  }

  return (
    <ClickceaseDomainMigrationWrapper>
      <Tooltip tooltiptContent={t('monitoring_mode_switch_tooltip')}>
        <SwitchWrapper>
          <Switch disabled={monitorMode} value={monitorMode} onChange={handleSetMonitorMode} />
        </SwitchWrapper>
      </Tooltip>
      <TableText>{t('monitoring_Mode')}</TableText>
    </ClickceaseDomainMigrationWrapper>
  )
}
